export function lineLayerId(layerId: string): string {
  return layerId + "/line";
}

export function fillLayerId(layerId: string): string {
  return layerId + "/fill";
}

export function simplifiedLayerId(layerId: string): string {
  return layerId + "/simplified";
}

export function selectedLayerId(layerId: string): string {
  return layerId + "/selected";
}

export function mapboxIdToAttributeId(mapboxId: string): string {
  const split = mapboxId.indexOf("/");
  if (split === -1) {
    return mapboxId;
  } else {
    return mapboxId.substring(0, split);
  }
}
